import React from "react";
import { motion } from "framer-motion";
import { advisoryLabel } from "@/lib/perspective";

// Animated weighted bars with advisory labels.
export const WeightedBars = ({ items }) => (
  <div className="space-y-5" data-testid="weighted-bars">
    {items.map((it, i) => (
      <div key={it.key || it.label}>
        <div className="mb-1.5 flex items-baseline justify-between">
          <span className="text-sm font-medium text-[var(--text-primary)]">{it.label}</span>
          <span className="text-xs font-medium text-[var(--accent-gold)]">{advisoryLabel(it.value)}</span>
        </div>
        <div className="h-1.5 w-full overflow-hidden rounded-full" style={{ background: "var(--border-subtle)" }}>
          <motion.div
            className="h-full rounded-full"
            style={{ background: "linear-gradient(90deg,#9ED3B8,var(--accent-gold),#0F4A36)" }}
            initial={{ width: 0 }}
            whileInView={{ width: `${it.value}%` }}
            viewport={{ once: true }}
            transition={{ duration: 1.1, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
          />
        </div>
      </div>
    ))}
  </div>
);

export default WeightedBars;
